import vm from '@/main';
import store from 'store/index';
import { handleExpiredSession } from '@/common/auth-navigation';
import axios from "axios";
import { ReturnBaseUrl } from "@/network/request";
import { identity } from "@/network/session-identity";
export function speechClient({ timeout = 30000 } = {}) {
  const scope = identity(),
    token = sessionStorage.getItem("token");
  const transport = axios.create({
    baseURL: ReturnBaseUrl() + "/speech/v1",
    timeout
  });
  const cancel = axios.CancelToken.source();
  return {
    close() {
      cancel.cancel("SPEECH_CLOSED");
    },
    async post(operation, data = {}, requestId) {
      if (scope !== identity())
        throw new Error("账号或服务器已变更，请重新进入页面。");
      let response;
      try {
        response = await transport.post(operation, data, {
          cancelToken: cancel.token,
          headers: {
            "X-User-Token": token,
            ...(requestId
              ? { "X-Request-Id": requestId, "Content-Type": "audio/wav" }
              : {})
          }
        });
      } catch (error) {
        if (axios.isCancel(error)) { error.silent = true; error.definitive = true; throw error; }
        throw new Error("语音服务连接中断，请稍后尝试或使用文字输入。");
      }
      if (scope !== identity())
        throw new Error("账号或服务器已变更，请重新进入页面。");
      if (response.data && response.data.code === 6) {
        handleExpiredSession(vm, store, { authToken: token }, response.data.message);
        const error = new Error('TOKEN_ERROR');
        error.silent = true;
        error.definitive = true;
        throw error;
      }
      if (!response.data || response.data.code !== 0) {
        const error = new Error(
          ((response.data || {}).data || {}).displayMessage ||
            "语音服务暂不可用，请稍后尝试或使用文字输入。"
        );
        error.definitive = !!(
          response.data &&
          response.data.data &&
          response.data.data.errorCode
        );
        throw error;
      }
      return response.data.data;
    }
  };
}
